
import { MapLocation } from '@/types/location';
import { abhaDigitalMegacomScreens } from './abhaScreens';
import { jizanDigitalMegacomScreens } from './jizanScreens';
import { najranDigitalMegacomScreens } from './najranScreens';
import { alBahahDigitalMegacomScreens } from './alBahahScreens';
import { muhayilDigitalMegacomScreens } from './muhayilScreens';
import { hailDigitalMegacomScreens } from './hailScreens';
import { qassimDigitalMegacomScreens } from './qassimScreens';
import { alKharjDigitalMegacomScreens } from './alKharjScreens';

export const digitalMegacomScreens: MapLocation[] = [
  ...abhaDigitalMegacomScreens,
  ...jizanDigitalMegacomScreens,
  ...najranDigitalMegacomScreens,
  ...alBahahDigitalMegacomScreens,
  ...muhayilDigitalMegacomScreens,
  ...hailDigitalMegacomScreens,
  ...qassimDigitalMegacomScreens,
  ...alKharjDigitalMegacomScreens
];
